import React, { useContext, useEffect, useState } from "react";
import { ClientContext } from "./clientContext.jsx/ClientContext";
import Home from "../Home/Home";
import Moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";

const api_url = process.env.REACT_APP_API_URL;

const EditClient = () => {
  const navigate = useNavigate();
  const {
    clientForEdit,
    productOptionData,
    productsData,
    allClientsData,
    setAllClientsData,
  } = useContext(ClientContext);

  if (!clientForEdit) {
    navigate("/clientlist");
  }

  const [message, setMessage] = useState("");
  const [editFormData, setEditFormData] = useState(clientForEdit);
  // console.log('✌️editFormData --->', editFormData);
  const [addOneProduct, setAddOneProduct] = useState(true);
  const [selectedProduct_Price, setSelectedProduct_Price] = useState(0);
  const [selectedProduct_Duration, setSelectedProduct_Duration] = useState(0);
  const [canChangeProduct, setCanChangeProduct] = useState(false);

  const handleDelete = (index) => {
    const newData = editFormData.products.filter((elem, ind) => ind != index);
    setEditFormData({ ...editFormData, products: newData });
    setAddOneProduct(true);
  };

  // ___________________________________________________user Authentication____________________
  useEffect(() => {
    fetch(`${api_url}/getuser`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const userObject = data.find(
          (user) => user._id === sessionStorage.userId
        );
        // setIsValidUser(userObject.active);
        if (!userObject.active) {
          navigate("/");
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  useEffect(() => {
    const fetchChangeProductPermission = async () => {
      try {
        const response = await fetch(`${api_url}/getprofiles`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status:${response.status}`);
        }
        const resData = await response.json();
        const userProfileData = resData.filter(
          (profile) => profile.profileName === sessionStorage.userProfile
        );
        setCanChangeProduct(
          !!userProfileData[0]?.status?.product?.changeProduct
        );
      } catch (error) {
        console.error("Error fetching change-product permission:", error);
        setCanChangeProduct(false);
      }
    };

    fetchChangeProductPermission();
  }, []);
  // ____________________________________________________________________________________________

  const handleAdd = () => {
    setEditFormData({
      ...editFormData,
      products: [
        ...editFormData.products,
        {
          productName: "",
          productPrice: 0,
          productDuration: "",
          fromDate: new Date(),
          toDate: new Date(),
          paidAmount: 0,
          dueAmount: 0,
          serviceStatus: "",
          kycStatus: "",
          saStatus: "",
        },
      ],
    });
  };

  const [adminName, setAdminName] = useState(() =>
    sessionStorage.getItem("displayName")
  );

  const handleCancel = () => {
    navigate("/clientlist");
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to allow only numbers 0-9
    const regex = /^[0-9]*$/;
    if (inputValue === "" || regex.test(inputValue)) {
      setEditFormData({ ...editFormData, clientId: inputValue })
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        userName: editFormData.userName,
        email: editFormData.email,
        clientPhoneNumber: editFormData.clientPhoneNumber,
        clientId:+editFormData.clientId,
        createdBy: editFormData.createdBy,
        updatedBy: adminName,
        products: editFormData.products.map((product) => ({
          productName: product.productName,
          productPrice: product.productPrice,
          productDuration: product.productDuration,
          fromDate: new Date(product.fromDate),
          toDate: new Date(product.toDate),
          serviceEndDate: new Date(),
          paidAmount: product.paidAmount,
          dueAmount: product.dueAmount,
          serviceStatus: product.serviceStatus,
          kycStatus: product.kycStatus,
          saStatus: product.saStatus,
        })),
      };
      // console.log("✌️payload --->", payload);
      const response = await fetch(`${api_url}/clients/${editFormData._id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();
      setMessage("Data submitted successfully");
      const newData = allClientsData.map((elem) =>
        editFormData._id == elem._id ? responseData.updatedClient : elem
      );
      setAllClientsData(newData);
      if (responseData) {
        navigate("/clientlist");
      }
    } catch (error) {
      setMessage("Failed to submit Data");
      console.error("Error", error);
    }
    setAddOneProduct(true);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...editFormData.products];
    const currentProduct = updatedProducts[index];
    const price =
      selectedProduct_Price || Number(currentProduct.productPrice) || 0;
    const duration =
      selectedProduct_Duration || Number(currentProduct.productDuration) || 0;

    if (field === "fromDate") {
      const inputDate = new Date(value);
      const serviceEndDate = new Date(
        inputDate.getTime() + duration * 24 * 60 * 60 * 1000
      );
      updatedProducts[index]["fromDate"] = new Date(value);
      updatedProducts[index]["toDate"] = serviceEndDate;
    } else if (field === "toDate") {
      updatedProducts[index]["toDate"] = new Date(value);
    } else if (field === "paidAmount") {
      updatedProducts[index]["paidAmount"] = value;
      updatedProducts[index]["dueAmount"] = price - value;
    } else {
      updatedProducts[index][field] = value;
    }

    setEditFormData({
      ...editFormData,
      products: updatedProducts,
    });
  };

  const handleChoseProduct = (index, event) => {
    const selectedProduct =
      event.target.options[event.target.selectedIndex].dataset.myDataAttribute;
    if (!selectedProduct) return;

    const selectedProductParts = selectedProduct.split("-");
    const selectedProduct_name = selectedProductParts[0];
    const selectedProduct_catergory = selectedProductParts[1];
    const selectedProduct_duration = parseInt(selectedProductParts[2], 10);
    let selectedPrice = parseFloat(selectedProductParts[3]) || 0;
    let selectedDuration = selectedProduct_duration;

    const selectedProductData = productsData?.find(
      (product) => product.productName === selectedProduct_name
    );

    if (selectedProductData) {
      const selectedProductCaps = selectedProductData.caps.filter(
        (cap) => cap.capCategory === selectedProduct_catergory
      );
      const selectedCap = selectedProductCaps.find(
        (cap) => cap.capDuration === selectedProduct_duration
      );
      if (selectedCap) {
        selectedPrice = selectedCap.capPrice;
        selectedDuration = selectedCap.capDuration;
      }
    }

    setSelectedProduct_Price(selectedPrice);
    setSelectedProduct_Duration(selectedDuration);

    // option value is "name|duration"; store productName as catalog name only
    const selectedOptionName =
      event.target.value?.split("|")[0] || event.target.value;

    const updatedProducts = [...editFormData.products];
    updatedProducts[index] = {
      ...updatedProducts[index],
      productName: selectedOptionName,
      productPrice: selectedPrice,
      dueAmount: selectedPrice,
      paidAmount: 0,
      productDuration: selectedDuration,
    };
    setEditFormData({
      ...editFormData,
      products: updatedProducts,
    });
  };

  return (
    <div>
      <Home />
      {editFormData && (
        <div className="form-container">
          <div className="form-align">
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={3}>
                  <h4>Edit General Information</h4>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label for="exampleCity">User Name</Label>
                    <Input
                      name="userName"
                      type="text"
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          userName: e.target.value,
                        })
                      }
                      defaultValue={editFormData.userName}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="exampleState">Email</Label>
                    <Input
                      name="email"
                      type="email"
                      disabled
                      // onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                      defaultValue={editFormData.email}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="exampleZip">Mobile Number</Label>
                    <Input
                      name="clientPhoneNumber"
                      type="tel"
                      min={0}
                      maxLength={10}
                      pattern="[0-9]*"
                      value={editFormData.clientPhoneNumber}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (/^\d{0,10}$/.test(inputValue)) {
                          setEditFormData({
                            ...editFormData,
                            clientPhoneNumber: inputValue,
                          });
                        }
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                <FormGroup>
                    <Label for="exampleZip">Client Id</Label>
                <Input
                    type="text"
                    name="userName"
                    required="true"
                    value={editFormData.clientId}
                    onChange={handleChange}
                  />
                </FormGroup>
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={3}>
                  <h4>Edit Product Information</h4>
                </Col>
              </Row>

              {editFormData.products?.map((product, index) => {
                return (
                  <div key={index}>
                    <Row>
                      <Col md={3}>
                        <h5>Product Details</h5>
                      </Col>
                      <Col md={2}>
                        <button
                          type="button"
                          style={{
                            border: "none",
                            padding: "10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                            display: "flex",
                            alignItems: "end",
                          }}
                          onClick={() => handleDelete(index)}
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            style={{
                              color: "red",
                              fontSize: "14px",
                            }}
                          />
                        </button>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Product Name</Label>
                          {!canChangeProduct && product._id ? (
                            <Input
                              type="text"
                              disabled
                              required
                              name={`products[${index}].productName`}
                              value={`${product.productName} $ ${product.productDuration}`}
                            />
                          ) : (
                            <Input
                              type="select"
                              required
                              name={`products[${index}].productName`}
                              value={
                                product.productName
                                  ? `${product.productName}|${product.productDuration}`
                                  : ""
                              }
                              onChange={(e) => handleChoseProduct(index, e)}
                            >
                              <option disabled value="">
                                --Select--
                              </option>
                              {productOptionData?.map((item) => (
                                <option
                                  key={`${item.name}-${item.capDuration}-${item.capPrice}`}
                                  className="dropdown_option"
                                  data-my-data-attribute={
                                    item.name +
                                    "-" +
                                    item.capDuration +
                                    "-" +
                                    item.capPrice
                                  }
                                  value={`${item.name}|${item.capDuration}`}
                                >
                                  {item.name}${item.capDuration}
                                </option>
                              ))}
                            </Input>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleState">Product Price</Label>
                          <Input
                            id="exampleState"
                            type="number"
                            disabled
                            name={`products[${index}].productPrice`}
                            min={0}
                            value={product.productPrice}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleCity">Paid Amount</Label>
                          <Input
                            id="exampleSelect"
                            type="number"
                            min={0}
                            required
                            name={`products[${index}].paidAmount`}
                            value={product.paidAmount}
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "paidAmount",
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleState">Due Amount</Label>
                          <Input
                            id="exampleState"
                            type="number"
                            name={`products[${index}].dueAmount`}
                            min={0}
                            value={product.dueAmount}
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "dueAmount",
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleCity">
                            From date{" "}
                            <span style={{ fontSize: "12px", fontWeight: 600 }}>
                              {" "}
                              (DD/MM/YYYY){" "}
                            </span>
                          </Label>
                          <Input
                            id="exampleSelect"
                            type="date"
                            required
                            name={`products[${index}].fromDate`}
                            value={formatDate(product.fromDate)}
                            // value={ handledate(product.fromDate)}
                            // onChange={(e) =>
                            //   setEditFormData({
                            //     ...editFormData,
                            //     products: editFormData.products.map((elem) =>
                            //       elem._id == product._id
                            //         ? { ...elem, fromDate: new Date(e.target.value) }
                            //         : new Date(e.target.value)
                            //     ),
                            //   })
                            // }
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "fromDate",
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleState">
                            To date{" "}
                            <span style={{ fontSize: "12px", fontWeight: 600 }}>
                              {" "}
                              (DD/MM/YYYY){" "}
                            </span>
                          </Label>
                          <Input
                            id="exampleState"
                            type="date"
                            required
                            name={`products[${index}].toDate`}
                            value={formatDate(product.toDate)}
                            // value={handledate(product.toDate)}
                            // defaultValue={product.toDate.format("YYYY-MM-DD")}
                            // onChange={(e) =>
                            //   setEditFormData({
                            //     ...editFormData,
                            //     products: editFormData.products.map((elem) =>
                            //       elem._id == product._id
                            //         ? { ...elem, toDate: new Date(e.target.value) }
                            //         : new Date(e.target.value)
                            //     ),
                            //   })
                            // }
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "toDate",
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col md={4}>
                                            <FormGroup>
                                                <Label for="exampleState">Service End date <span style={{ fontSize: "12px", fontWeight: 600 }}> (DD/MM/YYYY) </span></Label>
                                                <Input
                                                    id="exampleState"
                                                    type="date"
                                                    name={`products[${index}].toDate`}
                                                    defaultValue={handledate(product.serviceEndDate)}
                                                    // value={handledate(product.serviceEndDate)}
                                                    // defaultValue={product.toDate.format("YYYY-MM-DD")}
                                                    onChange={(e) => setEditFormData({ ...editFormData, products: editFormData.products.map((elem) => elem._id == product._id ? { ...elem, serviceEndDate: e.target.value } : elem) })}
                                                />
                                            </FormGroup>
                                        </Col> */}
                    </Row>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleCity">Service Status</Label>
                          <Input
                            id="exampleSelect"
                            type="select"
                            required
                            name={`products[${index}].serviceStatus`}
                            value={product.serviceStatus}
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "serviceStatus",
                                e.target.value
                              )
                            }
                          >
                            <option disabled value="">
                              --Select--
                            </option>
                            <option>Active</option>
                            <option>Expired</option>
                            <option>Hold</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleState">Kyc Status</Label>
                          <Input
                            id="exampleState"
                            type="select"
                            required
                            name={`products[${index}].kycStatus`}
                            value={product.kycStatus}
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "kycStatus",
                                e.target.value
                              )
                            }
                          >
                            <option value="">--Select--</option>
                            <option>Yes</option>
                            <option>No</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleState">SA Status</Label>
                          <Input
                            id="exampleState"
                            type="select"
                            required
                            name={`products[${index}].saStatus`}
                            value={product.saStatus}
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "saStatus",
                                e.target.value
                              )
                            }
                          >
                            <option value="">--Select--</option>
                            <option>Yes</option>
                            <option>No</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                );
              })}
              <br />
              <Row>
                <Col md={4}></Col>
                <Col md={2}>
                  <button
                    className="btn btn-success"
                    type="cancel"
                    style={{
                      backgroundColor: "#259D90",
                      border: "1px solid lightgray",
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </Col>
                <Col md={2}>
                  {addOneProduct ? (
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleAdd}
                    >
                      Add Product
                    </button>
                  ) : (
                    " "
                  )}
                </Col>
                <Col md={2}>
                  <button
                    className="btn btn-success"
                    type="submit"
                    style={{
                      backgroundColor: "#259D90",
                      border: "1px solid lightgray",
                    }}
                  >
                    Submit
                  </button>
                  <br />
                  <p>{message}</p>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditClient;
